interface RatingProps {
  value: number;
  count?: number;
  size?: "sm" | "md";
}

export default function Rating({ value, count, size = "sm" }: RatingProps) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  const starClass = size === "md" ? "text-base" : "text-sm";
  return (
    <div className="flex items-center gap-1.5">
      <div className="flex items-center text-primary-500">
        {Array.from({ length: 5 }).map((_, i) => {
          if (i < full) return <i key={i} className={`ri-star-fill ${starClass}`}></i>;
          if (i === full && half) return <i key={i} className={`ri-star-half-fill ${starClass}`}></i>;
          return <i key={i} className={`ri-star-line ${starClass} text-background-400`}></i>;
        })}
      </div>
      <span className="text-xs font-semibold text-foreground-800">{value.toFixed(1)}</span>
      {typeof count === "number" && <span className="text-xs text-foreground-500">({count.toLocaleString()})</span>}
    </div>
  );
}